import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import { TextButton } from "@/components/molecules/cta-button/cta-buttons";

type MTAConsentNoModalProps = {
  modalContentOne: string;
  modalCancelBtnText: string;
  modalConfirmBtnText: string;
  modalConfirmBtnClick: (action: boolean) => void;
};

function MTAConsentNoModal(props: MTAConsentNoModalProps) {
  const {
    modalContentOne,
    modalCancelBtnText,
    modalConfirmBtnText,
    modalConfirmBtnClick,
  } = props;

  return (
    <>
      <RichText
        richText={modalContentOne}
        className="text-start mb-spacing-s text-xs leading-[27px] font-normal text-text-body"
      />
      <div className="flex flex-col justify-center items-center gap-spacing-l">
        <TextButton
          id="modal-confirm-button"
          hierarchy="primary"
          data-testid="confirm-button"
          label={modalConfirmBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(true);
            }
          }}
          className={` md:mr-2 md:mb-0 mb-2 !h-[48px]  leading-[18px] w-full !text-text-functional-1`}
        />
        <TextButton
          id="modal-cancel-button"
          hierarchy="tertiary"
          data-testid="cancel-button"
          label={modalCancelBtnText as string}
          onClick={() => {
            if (modalConfirmBtnClick) {
              modalConfirmBtnClick(false);
            }
          }}
          isLeftIcon={false}
          className=" text-xs leading-[18px] font-semibold"
        />
      </div>
    </>
  );
}

export default MTAConsentNoModal;
